(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById('main-header');
    const homeHero = document.querySelector('.home-hero');
    const burgerBtn = document.getElementById('burger-menu-btn');
    const menu = document.getElementById('mobile-menu');

    if (!header || !burgerBtn || !menu) return;

    function updateHeaderBackground() {
      if (!homeHero) {
        header.classList.add('scrolled');
        return;
      }

      const heroBottom = homeHero.offsetTop + homeHero.offsetHeight;
      header.classList.toggle('scrolled', window.scrollY > heroBottom - 100);
    }

    function openMenu() {
      menu.classList.add('active');
      header.classList.add('menu-active');
      menu.setAttribute('aria-hidden', 'false');
      burgerBtn.setAttribute('aria-expanded', 'true');
      burgerBtn.setAttribute('aria-label', 'Close menu');
    }

    function closeMenu() {
      menu.classList.remove('active');
      header.classList.remove('menu-active');
      menu.setAttribute('aria-hidden', 'true');
      burgerBtn.setAttribute('aria-expanded', 'false');
      burgerBtn.setAttribute('aria-label', 'Open menu');
      updateHeaderBackground();
    }

    function toggleMenu() {
      menu.classList.contains('active') ? closeMenu() : openMenu();
    }

    updateHeaderBackground();
    window.addEventListener('scroll', updateHeaderBackground, { passive: true });
    burgerBtn.addEventListener('click', toggleMenu);
    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('click', function (event) {
      if (!menu.classList.contains('active')) return;
      if (!menu.contains(event.target) && !burgerBtn.contains(event.target)) closeMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('active')) {
        closeMenu();
        burgerBtn.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
